import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import {
  BannerComponent,
  Card,
  IconList,
  LevelNav,
  ProgressBar,
  Radio,
} from 'common/components';
import { labelToValue } from 'common/utils';

const StorageForm = props => {
  const { onSubmit, storages, selectedCrop } = props;

  const getContent = storage => {
    let list = [];
    if (storage.crop) {
      list.push({
        label: `${storage.crop.name} ${
          storage.crop.variety ? storage.crop.variety : ''
        }`,
        icon: 'crop',
      });
    }
    list.push({ label: `${storage.contentValue.value}`, icon: 'dollar' });
    return list;
  };

  const match = selectedCrop && JSON.parse(selectedCrop);
  let selectedStorages = match
    ? storages.filter(
        storage => storage.crop && storage.crop.name === match.name
      )
    : storages;
  // free space order for now
  if (selectedStorages && selectedStorages.legnth > 1) {
    selectedStorages.sort(
      (a, b) => b.capacity.pending.size - a.capacity.pending.size
    );
  }

  return (
    <Fragment>
      <BannerComponent
        theme={['static', 'strong', 'large', 'mobile-fixed']}
        message={
          <LevelNav
            nav={{
              left: {
                label: <span className={'visible--desktop'}>Back</span>,
                action: () => onSubmit(),
              },
              center: { label: 'Add Storage' },
            }}
          />
        }
      />

      <form>
        {selectedStorages && selectedStorages.length === 0 && (
          <p className={'text--center text--medium'}>
            No Storages with {match.name} {match.variety}
          </p>
        )}

        {selectedStorages && selectedStorages.length > 0 && (
          <Fragment>
            <p className={'text--fade'}>
              <small>Select a storage from the list below to add.</small>
            </p>

            <div className={'field'}>
              {selectedStorages &&
                selectedStorages.map((storage, idx) => {
                  const { id, name, capacity } = storage;
                  return (
                    <Radio
                      key={idx}
                      onChange={onSubmit}
                      label={
                        <Card
                          footer={
                            capacity && (
                              <ProgressBar
                                value={capacity.used}
                                max={capacity.size}
                                unit={capacity.type.slice(0, 2)}
                              />
                            )
                          }
                        >
                          <h3 className={'cardlist__title'}>{name}</h3>
                          <IconList list={getContent(storage)} />
                        </Card>
                      }
                      name={'storage'}
                      id={`storage-${labelToValue(name)}`}
                      val={JSON.stringify({
                        id,
                        name,
                        type: id.split(':')[0],
                        max: Number(capacity.used),
                      })}
                      theme={['card']}
                    />
                  );
                })}
            </div>
          </Fragment>
        )}
      </form>
    </Fragment>
  );
};

StorageForm.propTypes = {
  // from redux form
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,

  // from mapstate
  selectedCrop: PropTypes.string,

  // manually added
  onSubmit: PropTypes.func.isRequired,
  storages: PropTypes.arrayOf(PropTypes.object),
};

StorageForm.displayName = 'ActivityForm/forms/StorageForm';

const formSettings = {
  form: 'activityform',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onChange: (values, dispatch, props) => {
    // TODO: this might need different condition
    if (values.storage) {
      props.submit();
    }
  },
};
const field = formValueSelector(formSettings.form);
const mapState = state => ({
  selectedCrop: field(state, 'crop'),
});
export default compose(
  connect(mapState),
  reduxForm(formSettings)
)(StorageForm);



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/forms/Storage.js